import {type RootState} from 'signin-app/redux/main-reducer';

export const didPrefetch = (state: RootState) => state.prefetch.didPrefetch;
export const isPrefetching = (state: RootState) => state.prefetch.isPrefetching;
export const lastPrefetch = (state: RootState) => state.prefetch.lastPrefetch;
